
const ComoVenderHero = () => {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/c0fefee8a914100aa1eb21b77e2ab125.jpg"
          alt="Cómo vender tu coche siniestrado o averiado en Gavá"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 text-center w-full pt-20">
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
          Cómo Vender tu Coche<br />
          <span className="text-emerald-400">Siniestrado o Averiado en Gavá</span>
        </h1>
        
        <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto leading-relaxed">
          Guía completa para vender tu coche al <strong>desguace en Gavá</strong> de forma rápida, segura y al mejor precio del mercado
        </p>
      </div>
    </section>
  );
};

export default ComoVenderHero;
